import React from "react";

import { Skeleton } from "@material-ui/lab";

export default function DFCardSkeleton({ loading, ...props }) {
  return (
    <>{loading ? <Skeleton animation="wave" {...props} /> : props.children}</>
  );
}
